import { render } from "./WashListCompletedArrivalProgress.vue?vue&type=template&id=38d1bdde"
import script from "./WashListCompletedArrivalProgress.vue?vue&type=script&lang=ts"
export * from "./WashListCompletedArrivalProgress.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCircularProgress});
